module.exports = __webpack_public_path__ + "static/img/pic1.ecc8a38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/pic1.jpg
// module id = C/w2
// module chunks = 0